<template>
  <EarTrainingGame :choices="choices">
    <SubTitle v-if="title">{{ title }}</SubTitle>
    <p>
      Listen to the triad and try to guess its type.
    </p>
  </EarTrainingGame>
</template>

<script>
import EarTrainingGame from "./EarTrainingGame";

export default {
  name: "TriadGame",
  components: { EarTrainingGame },
  props: {
    title: { type: String, default: "Guess the triad" }
  },
  data: () => ({
    choices: [
      { name: "major", notes: ["C4", "E4", "G4"] },
      { name: "minor", notes: ["C4", "Eb4", "G4"] },
      { name: "diminished", notes: ["C4", "Eb4", "Gb4"] },
      { name: "augmented", notes: ["C4", "E4", "G#4"] }
    ]
  })
};
</script>
